export default __webpack_public_path__ + "static/media/img-mwa-6.35e7ada8.png";